import { RoutineType, VerificationRoutineMaster } from '../types/routine.types';
import axiosInstance from '../utils/axios-instance';
import { PostResponse } from '../types/common.types';

// #region GET
export const getRoutines = async (): Promise<RoutineType[]> => {
	const url: string = `/VerificationRoutine/GetAllRoutines`;
	return axiosInstance.get(url);
};

export const getVerRoutineMaster = async (): Promise<VerificationRoutineMaster> => {
	const url: string = `/VerificationRoutine/GetMaster`;
	return axiosInstance.get(url);
};

export const getRoutineById = async (id: string): Promise<RoutineType> => {
	const url: string = `/VerificationRoutine/GetRoutine?id=${id}`;
	return axiosInstance.get(url);
};

export const getBlobSasToken = async (): Promise<string> => {
	const url: string = `/VerificationRoutine/GetBlobSasToken`;
	return axiosInstance.get(url);
};

export const downloadFile = async (blobPath: string, fileName: string): Promise<any> => {
	const url: string = `/VerificationRoutine/Download?blobPath=${blobPath}&fileName=${fileName}`;
	return axiosInstance.get(url, {
		responseType: 'blob',
	});
};
// #endregion

// #region POST
export const saveVerificationRoutine = async (request: RoutineType): Promise<PostResponse> => {
	const url: string = `/VerificationRoutine/SaveVerificationRoutine`;
	return await axiosInstance.post(url, request);
};

export const updateVerificationRoutine = async (request: RoutineType): Promise<PostResponse> => {
	const url: string = `/VerificationRoutine/UpdateVerificationRoutine`;
	return await axiosInstance.post(url, request);
};

export const uploadFile = async (saveRequest: FormData): Promise<PostResponse | any> => {
	const url: string = `/VerificationRoutine/Upload`;
	return axiosInstance.post(url, saveRequest, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};
// #endregion

// #region DELETE
export const deleteFile = async (blobPath: string, fileName: string): Promise<PostResponse | any> => {
	const url: string = `/VerificationRoutine/Delete?blobPath=${blobPath}&fileName=${fileName}`;
	return axiosInstance.delete(url);
};
// #endregion
